import React, { FC } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { useQuery } from '@apollo/react-hooks';
import USER_SUMMARY_QUERY from './query.graphql';
import { CrumbDivider, Crumb } from '../Breadcrumbs';
import { combineStrings } from '../../../../../Shared/utils';

export { USER_SUMMARY_QUERY };

export type UserSummary = {
  id: string;
  firstName: string;
  lastName: string;
};

type UserRouteParams = {
  userId: string;
};

export const UserCrumbs: FC<RouteComponentProps<UserRouteParams>> = ({
  match,
}) => {
  const userId = match.params.userId;
  const { data } = useQuery<{ portalUser: UserSummary }>(USER_SUMMARY_QUERY, {
    variables: { userId },
    skip: !userId || userId === 'create',
  });
  const user = data && data.portalUser;

  return (
    <>
      {user && (
        <>
          <CrumbDivider />
          <Crumb>{combineStrings([user.firstName, user.lastName])}</Crumb>
        </>
      )}
    </>
  );
};
